import { render, staticRenderFns } from "./salinvoiceshipnoteimport.vue?vue&type=template&id=12576758&scoped=true&"
import script from "./salinvoiceshipnoteimport.vue?vue&type=script&lang=js&"
export * from "./salinvoiceshipnoteimport.vue?vue&type=script&lang=js&"
import style0 from "./salinvoiceshipnoteimport.vue?vue&type=style&index=0&id=12576758&lang=scss&scoped=true&"
import style1 from "./salinvoiceshipnoteimport.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12576758",
  null
  
)

export default component.exports